export const FETCH_APPLINKS_FAILURE = 'state.actions.fetch-applinks-failure.FETCH_APPLINKS_FAILURE';

export type FetchAppLinksFailurePayload = {
	statusCode: number;
};

export type FetchAppLinksFailureAction = {
	type: typeof FETCH_APPLINKS_FAILURE;
	payload: FetchAppLinksFailurePayload;
};

export const fetchAppLinksFailure = (
	error: FetchAppLinksFailurePayload,
): FetchAppLinksFailureAction => ({
	type: FETCH_APPLINKS_FAILURE,
	payload: error,
});
